import useApi from "./useApiRequest";
import { useMutation } from "react-query";

export const GetEntrada = ()  => {
    const api = useApi();

    const mutate = async (param) => {
        const data  = await api.get(`/documentos/${param}`);
        return data.data;
    };

    const mutation = useMutation(mutate);

    return {
        getEntradaMutation: mutation.mutate,
    };
}